import {buildPinpointCompatibleDevice} from "./deviceInfo";
import {PinpointCompatibleEventMetadata} from "./pinpointCompatibility";

export interface PinpointBrowserEventState {
    hash: string;
    path: string;
    referrer: string;
    search: string;
    title: string;
    host: string;
    url: string;
    userAgent: string;
    platform?: string;
}

export interface PinpointSessionEventState {
    id: string;
    startMs: number;
    elapsed?: number;
}

export interface PinpointEventMetadataInput {
    eventType: string;
    eventTime: Date;
    session: PinpointSessionEventState;
    pageSession: string;
    anonId: string;
    userId: string | null;
    browser: PinpointBrowserEventState;
    campaign?: Record<string, string>;
}

export function buildPinpointEventMetadata({
    eventType,
    eventTime,
    session,
    pageSession,
    anonId,
    userId,
    browser,
    campaign = {},
}: PinpointEventMetadataInput): PinpointCompatibleEventMetadata {
    const eventTimestamp = eventTime.getTime();
    const utmAttributes = Object.fromEntries(Object.entries(campaign).map(([key, value]) => [`utm_${key}`, value]));

    return {
        attributes: {
            date: eventTime.toISOString(),
            sessionId: session.id,
            pageSession,
            anonId,
            userId,
            hash: browser.hash,
            path: browser.path,
            referrer: browser.referrer,
            search: browser.search,
            title: browser.title,
            host: browser.host,
            url: browser.url,
            ...utmAttributes,
        },
        metrics: {
            // Match the plugin: an elapsed value of zero falls back to the timestamp difference.
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            sessionTime: session.elapsed || eventTimestamp - session.startMs,
            hour: eventTime.getHours(),
            day: eventTime.getDay() + 1,
            month: eventTime.getMonth() + 1,
            year: eventTime.getFullYear(),
        },
        session: {
            session_id: session.id,
            start_timestamp: session.startMs,
            ...(eventType === "_session.stop" ? {stop_timestamp: eventTimestamp} : {}),
        },
        device: {...buildPinpointCompatibleDevice(browser.userAgent, browser.platform)},
        eventTimestamp,
    };
}
